module.exports = __webpack_public_path__ + "static/media/estate-clarity-create-userflow.049adbe6.jpg";